import "./Des_Products.scss";
import { ConfigProvider, Input } from "antd";
const { TextArea } = Input;

function Des_Products({ onChangeDescription }) {
  return (
    <>
      <div className="des-products">
        <ConfigProvider
          theme={{
            components: {
              Input: {
                activeBorderColor: "#000",
                hoverBorderColor: "#000",
                activeShadow: "none",
              },
            },
          }}
        >
          <TextArea
            className="no-resize"
            allowClear={true}
            rows={4}
            onChange={(e) => onChangeDescription(e.target.value)}
            placeholder="Nhập mô tả sản phẩm..."
          />
        </ConfigProvider>
      </div>
    </>
  );
}

export default Des_Products;
